import moment from 'moment';
import { formatMonthTitleCN, isGreaterChinaLocale } from '@marriott/shared/mi-helper-utils';
import { convertToUpperCase } from '../../../../../../utils/src/utils';
import type { ShopPageSingleDateHeaderProps } from './shopPageSingleDateHeader.types';
import { getLocalizedDate } from '@marriott/mi-ui-library';
import { FLEXIBLE_FORMAT_YEAR_MONTH } from '../../../../../../constants/Calendar.constant';
import { formatDateStringBasedOnLocale } from '../../../../../../utils/src/helper';
import { AR_LOCALE, HI_LOCALE } from '../../../../../../modules/constants/Calendar.constants';

export const getDateText = (
  monthSelected: ShopPageSingleDateHeaderProps['monthSelected'],
  yearSelected: ShopPageSingleDateHeaderProps['yearSelected'],
  currentLocale: string,
  dateFormatInput?: string
): string => {
  if (!monthSelected) {
    return 'Check-in - Checkout';
  }

  if (isGreaterChinaLocale(currentLocale)) {
    return formatMonthTitleCN({ year: yearSelected, month: monthSelected - 1 });
  }

  // Adding 1 as the default 'day' value since we only use month and year for flex date scenarios anyway
  const localizedDate = getLocalizedDate(
    moment(new Date(yearSelected ?? new Date().getFullYear(), monthSelected - 1, 1)),
    dateFormatInput ?? FLEXIBLE_FORMAT_YEAR_MONTH,
    currentLocale
  );
  let returnedDate = convertToUpperCase(localizedDate, currentLocale);
  returnedDate = formatDateStringBasedOnLocale(returnedDate);
  return returnedDate;
};
